import React from 'react';
import '../styles/footer.css';
import { Link, NavLink } from 'react-router-dom';

function Footer() {
    return (
        <footer className='footer-container-main'>

            {/* Principal*/}

            <div className='py-3'>
                <div className='container-xxl'>
                    <div className='row d-flex align-item-center justify-content-around'>

                        {/*Logo*/}
                        <div className='col-lg-3 logo-container-footer text-center'>

                            <div className='d-flex justify-content-center'>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Logo1-bg.png`} className="img-fluid logo-footer" alt="Defiendeme" /></NavLink>
                            </div>

                            <div className='d-flex justify-content-around align-item-center mt-2 icons'>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Instagram.svg`} className="icon" alt="Defiendeme" /></NavLink>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Whatsapp.svg`} className="icon" alt="Defiendeme" /></NavLink>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Facebook.svg`} className="icon" alt="Defiendeme" /></NavLink>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Youtube.svg`} className="icon" alt="Defiendeme" /></NavLink>
                                <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Linkedin.svg`} className="icon" alt="Defiendeme" /></NavLink>
                            </div>

                        </div>

                        {/*Direccion*/}
                        <div className='col-lg-2 mt-1 d-flex py-3'>
                            <div className='footer-container d-flex justify-content-center flex-column '>
                                <h5>Bogotá</h5>
                                <p>Calle 64 N° 67a - 55</p>
                                <p>Salite El Greco</p>
                                <p>(+57) 3214077576</p>
                            </div>
                        </div>

                        {/*Enlaces*/}
                        <div className='col-lg-2 mt-1 d-flex py-3'>
                            <div className='footer-container d-flex justify-content-center flex-column '>
                                <h5>Enlaces</h5>
                                <Link to='/services' className=''>Servicios</Link>
                                <Link to='/Areas' className=''>Áreas de práctica</Link>
                                <Link to='/team' className=''>Nuestro equipo</Link>
                            </div>
                        </div>

                        {/*Interés*/}
                        <div className='col-lg-2 mt-1 d-flex py-3'>
                            <div className='footer-container d-flex justify-content-center flex-column '>
                                <h5>Interés</h5>
                                <Link to='/politica-privacidad' className=''>Política de Privacidad</Link>
                                <Link to='/politica-privacidad' className=''>Tratamiento de datos</Link>
                                <Link to='/actualidad' className=''>Actualidad</Link>
                            </div>
                        </div>

                        {/*Contacto*/}
                        <div className='col-lg-2 mt-1 d-flex py-3'>
                            <div className='footer-container d-flex justify-content-center flex-column '>
                                <h5>Contacto</h5>
                                <Link to='/contact' className=''>Servicio al cliente</Link>
                                <Link to='https://wa.me/573505656305' target="_blank" rel="noopener noreferrer" className=''>Whatsapp</Link>
                                <Link to='mailto:servicioalcliente@defiendeme.com.co' className=''>Envianos un correo</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            {/* CopyRigh*/}
            <div className='footer__copyright py-3'>
                <div className='container-xxl'>
                    <div className='row'>
                        <p className='mb-0 text-white text-center'>
                            &copy; {new Date().getFullYear()} Powered by Developer´s GRAVITI
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
